import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_REQUISITION_DROP_DOWN } from 'Store/AssetManagement/RequisitionDropDown/RequisitionDropDownType';
import { setRequistionDropDown } from 'Store/AssetManagement/RequisitionDropDown/RequisitionDropDownAction';

function* getRequisitionDropDownSaga(req: any): any {

    let payloadData : IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `catalog/attribute/RequisitionDropDown`,
        payload : req.payload
    }

    try {
        yield put(globalLoaderText("Fetching Reason Types...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setRequistionDropDown({response: response, childAttributeName: req.payload.childAttributeName, fleetRequestDetailId: req.payload.fleetRequestDetailId}))
        } else {
            yield put(setRequistionDropDown([]))
        }

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setRequistionDropDown([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetRequisitionDropDown() {
    yield takeEvery(GET_REQUISITION_DROP_DOWN, getRequisitionDropDownSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetRequisitionDropDown()
    ])
}
